import React from "react";
import OrderSettings from "./order-setting";
import Khalti from "./khalti";
import Bank from "./bank";
import Column from "@components/column";
import Esewa from "./esewa";

const Payment = () => {
  return (
    <Column>
      <OrderSettings />
      <Khalti />
      <Esewa />
      <Bank />
    </Column>
  );
};

export default Payment;
